module.exports = __webpack_public_path__ + "img/forgot-password-v2.c1364a77.svg";